import { render, staticRenderFns } from "./CoozzySortDropdown.vue?vue&type=template&id=351a18dc&scoped=true"
import script from "./CoozzySortDropdown.vue?vue&type=script&lang=js"
export * from "./CoozzySortDropdown.vue?vue&type=script&lang=js"
import style0 from "./CoozzySortDropdown.vue?vue&type=style&index=0&id=351a18dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351a18dc",
  null
  
)

export default component.exports